import { useUserStore } from '@/modules/profile/stores/user.ts';
import {
  removeAllTokensFromStorage,
  getAccessToken,
  isAccessTokenExpired,
  refreshTokens,
} from '@/shared/tools/jwt.ts';
import { storeToRefs } from 'pinia';
import { RouteLocationNormalized, useRouter } from 'vue-router';
import { useProfileApi } from '@/modules/profile/composables/api/useProfileApi.ts';
import { UserApi } from '@/modules/profile/composables/api/useUserApi.ts';
import { apolloClient } from '@/core/apollo/client.ts';
import { Capacitor } from '@capacitor/core';
import { useInviteStore } from '@/modules/invite/stores/invite';

export const goToSignIn = ({ redirect }: { redirect?: string } = {
}) => {
  if (redirect) {
    localStorage.setItem('redirectOnLogin', redirect);
  }

  const router = useRouter();

  if (router) {
    router.push({
      name: 'Login',
    });
  } else {
    window.location.href = '/login';
  }
};

const isPublicPage = (route: RouteLocationNormalized): boolean => {
  if (route.meta.public) {
    return true;
  }

  switch (route.name) {
    case 'Login':
    case 'LoginGoogleCallback':
      return true;
    default:
      return false;
  }
};

export interface AuthMiddlewareOptions {
  appHttpEndpoint: string;
}

export const useAuthMiddleware = (opts: AuthMiddlewareOptions) => async (to: RouteLocationNormalized) => {
  const refreshTokenUrl = opts.appHttpEndpoint + '/auth/refresh-token';

  if (isPublicPage(to)) {
    return;
  }

  if (!getAccessToken()) {
    goToSignIn({
      redirect: to.path,
    });

    return false;
  }

  if (isAccessTokenExpired()) {
    try {
      await refreshTokens(refreshTokenUrl);
    } catch (e) {
      console.error(e);
      goToSignIn({
        redirect: to.path,
      });

      return false;
    }
  }

  const { user } = storeToRefs(useUserStore());
  const inviteStore = useInviteStore();

  if (!user.value) {
    const { getMe } = useProfileApi();

    try {
      user.value = await getMe();

      const userApi = new UserApi(apolloClient);

      if (Capacitor.isNativePlatform()) {
        userApi.updateUser({
          id: user.value.id,
          fcmToken: localStorage.getItem('pushNotificationsToken') || '',
        });
      }

      const redirect = await inviteStore.resolveInviteAfterAuth(to);
      if (redirect) {
        return redirect;
      }
    } catch (e) {
      console.error(e);

      removeAllTokensFromStorage();

      goToSignIn({
        redirect: to.path,
      });

      return false;
    }

    // const userApi = new UserApi();
    // user.value = await userApi.provideGetUser();
    return;
  }

  // if (!user.value?.fcmToken) {
  //   const pushNotificationsToken = localStorage.getItem('pushNotificationsToken');

  //   if (pushNotificationsToken) {
  //     await userApi.setFcmToken(user.value.id, pushNotificationsToken);
  //   }
  // }

  const redirect = await inviteStore.resolveInviteAfterAuth(to);
  if (redirect) {
    return redirect;
  }
};
